<template>
  <div class="request-error-state">
    <font-awesome-icon :icon="['fal', 'exclamation-triangle']"/>
    <p class="message">{{ errorMessage }}</p>
    <p v-if="tryAgainHandler" class="actions">
      <button class="btn btn-secondary" @click="tryAgainHandler">{{ $t('try_again') }}</button>
    </p>
  </div>
</template>

<script>
  export default {
    name: "request-error-state",
    i18nOptions: {namespaces: ['state']},
    props: ['tryAgainHandler', 'message'],
    computed: {
      errorMessage: function () {
        return this.message ? this.message : this.$t('request_error_message');
      },
    },
  }
</script>

<style scoped>
  .request-error-state {
    width: 100%;
    padding: 90px 0;
    text-align: center;
    color: #999;
  }

  .svg-inline--fa {
    display: inline-block;
    width: 45px;
    height: 45px;
  }

  .message {
    margin-top: 20px;
  }
</style>
